import * as React from 'react'
import { AddOrEditLoyaltyTier, IBaseLoyaltyTier } from '@getgreenline/homi-shared'
import { Currency } from '../../../components/Currency'
import { LoyaltyTypes } from '@getgreenline/loyalties'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { inject, observer } from 'mobx-react'

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}
interface Props {
  loyaltyTier: IBaseLoyaltyTier | AddOrEditLoyaltyTier
}

const _LoyaltySummarySection = ({ loyaltyTier }: Props & InjectedProps) => (
  <>
    <li>
      <span>
        For customers in the <b>{loyaltyTier.name || '-'}</b> tier
      </span>
    </li>
    <li>
      <span>They will receive </span>
      <b>{loyaltyTier.creditAmount + ' points'}</b>
      {loyaltyTier.type === LoyaltyTypes.PER_VISIT ? (
        <span>
          {' '}
          per <b>visit</b>
        </span>
      ) : (
        <span>
          {' '}
          per{' '}
          <b>
            <Currency centValue={loyaltyTier.creditAmountPer} /> spent
          </b>
        </span>
      )}
    </li>
    <li>
      {loyaltyTier.minimumRequiredPurchase ? (
        <span>
          <span>Customers must spend at least </span>
          <b>
            <Currency centValue={loyaltyTier.minimumRequiredPurchase} />
          </b>
          <span> in order to receive points</span>
        </span>
      ) : (
        <span>Customers don't have a minimum spend requirement to get points</span>
      )}
    </li>
  </>
)

export const LoyaltySummarySection = inject('currentCompanyStore')(observer(_LoyaltySummarySection))
